import axios from "axios";
import { LS } from "../_helpers";
import { appNotification } from "../_components";
import { currentUserConstants, apiConstants } from "../_constants";
const {
  CHANGE_USER,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  GET_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_FAIL,
} = currentUserConstants;

const { USER_URL, PERMISSIONS_URL } = apiConstants;

const changeUser = (user) => {
  LS.save("current-user", user);
  return {
    type: CHANGE_USER,
    payload: user,
  };
};

const fetchUserAndPermissions = () => {
  const getUser = () => axios.get(USER_URL);
  const getPermissions = () => axios.get(`${PERMISSIONS_URL}`);
  return (dispatch) => {
    axios
      .all([getUser(), getPermissions()])
      .then(
        axios.spread((...responses) => {
          const user = responses[0].data;
          const permissions = responses[1].data;
          dispatch({
            type: GET_USER_SUCCESS,
            payload: user,
          });
          dispatch({
            type: GET_PERMISSIONS_SUCCESS,
            payload: permissions,
          });
        })
      )
      .catch((errors) => {
        appNotification(errors, "Unable to get user's details", "error");
        dispatch({
          type: GET_USER_FAIL,
          payload: errors,
        });
        dispatch({
          type: GET_PERMISSIONS_FAIL,
          payload: errors,
        });
      });
  };
};

const currentUserActions = {
  changeUser,
  fetchUserAndPermissions,
};

export default currentUserActions;
